(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setButtonState(button, video) {
    const paused = video.paused;
    button.textContent = paused ? 'Afspelen' : 'Pauze';
    button.setAttribute('aria-label', paused ? 'Video afspelen' : 'Video pauzeren');
  }

  function initialize(root = document) {
    root.querySelectorAll('[data-bb-hero-video-toggle]').forEach((button) => {
      if (button.dataset.initialized) return;
      const video = button.closest('.bb-home-hero__media')?.querySelector('video');
      if (!video) {
        button.hidden = true;
        return;
      }

      button.dataset.initialized = 'true';
      if (reducedMotion.matches) video.pause();
      video.addEventListener('pause', () => setButtonState(button, video));
      video.addEventListener('play', () => setButtonState(button, video));
      button.addEventListener('click', () => {
        if (video.paused) {
          video.play().catch(() => setButtonState(button, video));
        } else {
          video.pause();
        }
      });
      setButtonState(button, video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
